.accountName {
  color: var(--core-text-10-color) !important;
}
